import { Component, Input, OnInit } from '@angular/core';
import { CommonService } from '../../../core/services/common/common.service';
import { HeaderTitle } from '../../enums/header-title.enum';
import { Router } from '@angular/router';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss']
})
export class HeaderComponent implements OnInit {
  @Input() title: string;
  @Input() Id: number = null;
  @Input() progress: number;
  constructor(public _commonService: CommonService, private router: Router) { }

  ngOnInit(): void {
  }

  onBackClick() {
    if (this.title === HeaderTitle.DashboardTitle) {
      this._commonService.redirect();
    }
    if (this.title === HeaderTitle.GroupDetails) {
      this.router.navigateByUrl('/dashboard');
    }
    if (this.title === HeaderTitle.PlansSelection) {
      this.router.navigateByUrl('/groupdetail');
    }
    if (this.title === HeaderTitle.Contribution) {
      this.router.navigateByUrl('/plans/' + this.Id);
    }
    if (this.title === HeaderTitle.Delivery) {
      this.router.navigateByUrl('/contribution/' + this.Id);
    }
  }

  onCrossClick() {
    if (this.title === HeaderTitle.GroupDetails      
      || this.title === HeaderTitle.PlansSelection
      || this.title === HeaderTitle.Contribution
      || this.title === HeaderTitle.Delivery) {
        this.router.navigateByUrl('/dashboard');
    }else if(this.title === HeaderTitle.DashboardTitle){
      this._commonService.redirect();
    }
  }
}
